function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  /* padding: 24px 0; */\n  a {\n    margin-right: 28px;\n    img {\n      /* width: 30px;\n      height: 30px; */\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Link from "../../Link/Link";
var WrapSocialLink = styled.div.withConfig({
    componentId: "sc-d6cae1a9-0"
})(_templateObject());
var SocialLinks = function() {
    return /*#__PURE__*/ _jsxs(WrapSocialLink, {
        children: [
            /*#__PURE__*/ _jsx(Link, {
                href: "/",
                external: true,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/images/socials/twitter.png",
                    alt: "",
                    width: "23"
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "/",
                external: true,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/images/socials/reddit.png",
                    alt: "",
                    width: "23"
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "/",
                external: true,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/images/socials/instagram.png",
                    alt: "",
                    width: "25"
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "/",
                external: true,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/images/socials/github.png",
                    alt: "",
                    width: "19"
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "/",
                external: true,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/images/socials/discord.png",
                    alt: "",
                    width: "25"
                })
            })
        ]
    });
};
export default /*#__PURE__*/ React.memo(SocialLinks, function() {
    return true;
});
